import React, {useState, useEffect, Fragment} from 'react';
import {Row, Col, Checkbox, Modal, Upload, Table} from "antd";

import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

import { useSelector, useDispatch } from "react-redux";

import Content from "../../commons/components/content";
import Pagination from "../../commons/components/pagination";
import Input from "../../commons/components/input";
import SearchInput from "../../commons/components/searchInput";
import ButtonIcon from "../../commons/components/buttonIcon";
import Loading from "../../commons/components/loading";
import Permissions from '../../commons/utils/permissions'

import {toast} from "react-toastify";

import ServiceApplication from '../../services/applications'

export default () => {

    const { screens } = useSelector(state => state.userLogin);
    const [permissions] = useState([]);

    const [loadingTable, setLoadingTable] = useState(true);
    
    const [actualPage, setActualPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [application, setApplication] = useState({})

    const [showModalApplication, setShowModalApplication] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [nomeError, setNomeError] = useState(false);
    const [descricaoError, setDescricaoError] = useState(false);

    const tableColumns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Ativo',
            dataIndex: 'active',
            key: 'active',
        },
        {
            title: 'Ação',
            key: 'action',
            render: (text, application) => (
                <div style={{ display: 'flex' }}>
                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_APLICACAO)) ?
                        <ButtonIcon className="button-edit" type="edit" text="Editar Aplicação" callback={() => handleEditApplication(application)}/>
                        : null
                    }

                    {(permissions.find(_function => _function.function_id === Permissions.EXCLUIR_APLICACAO)) ?
                        <ButtonIcon className="button-red" type="delete" text="Excluir Aplicação" callback={() => handleDeleteApplication(application)}/>
                        : null
                    }                    
                </div>
            ),
        },
    ];
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        screens.map(screen => {
            if (screen.url === "/applications") {
                screen.functions.map(func => {
                    permissions.push(func)
                })
            }
        });
    }, []);    

    useEffect(()=>{
        if(search === ""){
            getApplications()
        }
    }, [search]);

    useEffect(()=>{
        setApplication({ ...application, logo: imageUrl })        
    }, [imageUrl]);

    function getImageBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function beforeUploadLogo(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          toast.error("Você só pode enviar arquivos JPG / PNG!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          toast.error("A imagem deve ter menos de 2 MB!");
        }
        return isJpgOrPng && isLt2M;
      }

    function onChangeLogo(info) {
        if (info.file.status !== 'uploading') {

        }
        if (info.file.status === 'done') {
            getImageBase64(info.file.originFileObj, base64Str => {setImageUrl(base64Str)});            
        } else if (info.file.status === 'error') {
            toast.error("Erro ao alterar logotipo");
        }
    }

    function getApplicationsOrSearch(page) {
        if (search === "") {
            getApplications(page)
        } else {
            searchApplication(search, page)
        }
    }

    async function getApplications(page = 1) {
        setLoadingTable(true);
        let response = await ServiceApplication.getAll(page)
        if (response){
            formatTable(response.data.data)
            setActualPage(page);
            setTotalPages(response.data.pagination);
            setLoadingTable(false);
        }
        setShowModalApplication(false)
    }

    async function getApplication(id) {
        setLoadingTable(true);
        let response = await ServiceApplication.getId(id)
        if (response){
            const data = response.data.data[0]
            setApplication(data);
            setImageUrl(data.logo);
            setLoadingTable(false);
        }
    }

    async function searchApplication(search) {
        setLoadingTable(true);
        let response = await ServiceApplication.search(search)
        if (response){
            formatTable(response.data.data);
            setActualPage(search);
            setTotalPages(response.data.pagination);            
            setLoadingTable(false);
        }
    }

    function formatTable(data) {
        let array = [];
        data.forEach((application) => {
            application.key = application.id;
            application.active = application.active === true ? "Sim" : "Não";
            array.push(application)
        })
        setTableData(array);
    }

    function handleSearch(e) {
        setSearch(e.target.value);
        if (search.length > 2) {
            searchApplication(search);
        }
    }

    function validateForm() {
        let valid = true;

        if (!application.name){
            setNomeError(true);
            toast.error("Informe o nome");
            valid = false;
        }

        if (!application.description){
            setDescricaoError(true);
            toast.error("Informe a descrição");
            valid = false;
        }

        return valid;
    }

    function handleSaveModalApplication() {
        setLoadingTable(true);
        if (validateForm()) {
            if (application.id) {
                update(application)
            } else {
                insert(application)
            }
        }
        setLoadingTable(false);
    }

    function handleConfirmDeleteApplication() {
        setLoadingTable(true);
        remove(application);
        toast.success(`Aplicação ${application.first_name} deletada!`)
        setShowDeleteModal(false);
        setLoadingTable(false);
    }

    function handleCancelModalApplication() {
        setApplication({});
        setShowModalApplication(false);

        setNomeError(false);
        setDescricaoError(false);
    }

    function handleCalcelDeleteApplication() {
        setApplication({});
        setShowDeleteModal(false);
    }

    function handleEditApplication(application) {
        setLoadingTable(true);
        getApplication(application.id);
        setShowModalApplication(true);
        setLoadingTable(false);
    }

    function handleDeleteApplication(application) {
        setLoadingTable(true);
        getApplication(application.id);
        setShowDeleteModal(true);
        setLoadingTable(false);
    }
    
    function handleKeyPress(e){
        if(e.key === "Enter"){
            handleSaveModalApplication();
        }
    }

    function returnConfirmAction() {
        if(search !== ""){
            searchApplication(search);
        }else{
            getApplications(actualPage)
        }
    }

    async function insert(data) {
        let response = await ServiceApplication.insert(data)
        returnConfirmAction()
    }

    async function update(data) {
        let response = await ServiceApplication.update(data)
        returnConfirmAction()
    }

    async function remove(data) {
        let response = await ServiceApplication.delete(data.id)
        returnConfirmAction()
    }

    const uploadButton = (
        <div>
            {loadingTable ? <LoadingOutlined/> : <PlusOutlined/>}
            <div className="ant-upload-text">Upload Logo</div>
        </div>
    );

    const newItemModal = () => (
        <Modal
            title="Cadastro de Aplicações" visible={showModalApplication} onCancel={handleCancelModalApplication}
            footer={[
                <button key="cancel" onClick={handleCancelModalApplication} className="btn btn-light">Cancelar</button>,
                <button key="confirm" onClick={handleSaveModalApplication} className="btn btn-primary">Salvar</button>
            ]}>
            
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Input
                            name="name" label="Nome" 
                            value={application.name ? application.name : ''}
                            hasError={nomeError}
                            onChange={(e) => { setApplication({ ...application, name: e.target.value }); setNomeError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Input
                            name="description" label="Descrição" 
                            value={application.description ? application.description : ''}
                            hasError={descricaoError}
                            onChange={(e) => { setApplication({ ...application, description: e.target.value }); setDescricaoError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Upload
                            name="file"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                            beforeUpload={beforeUploadLogo}
                            onChange={onChangeLogo}
                        >
                            {imageUrl ? <img src={imageUrl} alt="Logotipo da aplicação" style={{ width: '100%' }} /> : uploadButton}
                        </Upload>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox
                            inputId="cbAtivo"
                            onChange={(e) => {setApplication({...application, active: e.target.checked})}}
                            checked={application.active} 
                        />
                        <label htmlFor="cb_ativo" className="p-checkbox-label" style={{marginLeft: '5px'}}>Ativo</label>
                    </div>
                </div>
            </div> 
        </Modal>
    );

    const deleteRoleModal = () => (
        <Modal visible={showDeleteModal} title="Excluir aplicação"
               onCancel={handleCalcelDeleteApplication} cancelText="Cancelar" onOk={handleConfirmDeleteApplication} okText="Excluir"
               okType="danger">

            <p>Tem certeza que deseja excluir a aplicação <strong>{application.name}</strong> ?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    const renderSearchApplication = () => (
        <div style={{marginBottom: 10}}>
            <SearchInput
                placeholder="Pesquisar..."
                onChange={handleSearch}
                value={search}
                buttonLabel="Limpar" type="close" callback={() => setSearch("")}/>
        </div>
    );

    const renderLoading = () => {
        if (loadingTable) {
            return (
                <div style={{display: "flex", justifyContent: "center"}}>
                    <Loading width={50} height={50}/>
                </div>
            )
        }
    };

    const renderAddApplicationButton = () => {
        if (permissions.find(_function => _function.function_id === Permissions.CADASTRAR_APLICACAO)) {
            function handleOpenModal() {
                setApplication({})
                setShowModalApplication(true)
            }

            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonIcon className="button-green" text="Adicionar Aplicação" type="plus" label="Adicionar"
                        callback={handleOpenModal} />
                </div>
            )
        }
    };

    const renderTable = () => (
        <Fragment>
            <Col span={24}>
                <div style={{ marginBottom: 20 }}>
                    <Table pagination={false} columns={tableColumns} dataSource={tableData} />
                </div>
            </Col>
        </Fragment>
    );

    const renderHeader = () => (
        <Fragment>
            <Col span={8}>
                {renderSearchApplication()}
            </Col>
            <Col span={10}>
                {renderLoading()}
            </Col>
            <Col span={6}>
                {renderAddApplicationButton()}
            </Col>
        </Fragment>
    );

    return (
        <>
            <Content breadcrumb={["Aplicações"]} minHeight={360}>
                {newItemModal()}
                {deleteRoleModal()}

                <Row type="flex" align="middle">
                    {renderHeader()}
                </Row>

                <Row>
                    {renderTable()}
                </Row>

                <Row type="flex" align="middle">
                    <Col span={12}>
                        <Pagination totalPages={totalPages} actualPage={actualPage} callBack={(page) => getApplicationsOrSearch(page)} />
                    </Col>
                </Row>
            </Content>
        </>
    )
}